export enum BannerDisplayTypeEnum {
  ActiveOrScheduled,
  Draft,
}
